import { axios } from '@/axios';
import routes from '@/web-api/routes';

const actions = {
  getReviewById({ commit, state }, { id }) {
    commit('setLoadingState', { loadingState: true }, { root: true });

    return new Promise((resolve, reject) => {
      if (id === state.id) {
        commit('setLoadingState', { loadingState: false }, { root: true });

        return resolve(state);
      }

      commit('resetReviewState');

      return axios.get(routes.ajax.reviews.get(id))
        .then((response) => {
          const {
            jobDetails, answers, questions, id: reviewId,
            completionPercentage,
          } = response.data.data;

          commit('updateJobDetails', { jobDetailsData: jobDetails });

          commit('updateReviewQuestions', { questions });

          commit('updateReviewAnswers', { answers });

          commit('updateReviewId', { reviewId });

          commit('updateCompletionPercentage', { completionPercentage });

          commit('setLoadingState', { loadingState: false }, { root: true });

          return resolve(response.data.data);
        })
        .catch((error) => {
          console.log(error);

          commit('setLoadingState', { loadingState: false }, { root: true });

          return reject(error);
        });
    });
  },

  deleteReview({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios.delete(routes.ajax.reviews.delete(id))
        .then((response) => {
          commit('updateUnfinishedReviews', { unfinishedReviews: response.data.data });

          return resolve(response.data.data);
        })
        .catch((error) => {
          console.log(error);
          return reject(error);
        });
    });
  },

  createReview({ commit, getters }, { payload }) {
    const jobDetailsPayload = getters.getFormattedJobDetailPayload(payload);

    return new Promise((resolve, reject) => {
      axios.post(routes.ajax.reviews.create, jobDetailsPayload)
        .then((response) => {
          const {
            jobDetails, answers, questions, id: reviewId, completionPercentage,
          } = response.data.data;

          commit('updateJobDetails', { jobDetailsData: jobDetails });

          commit('updateReviewQuestions', { questions });

          commit('updateCompletionPercentage', { completionPercentage });

          commit('updateReviewAnswers', { answers });

          commit('updateReviewId', { reviewId });

          return resolve(response.data.data);
        })
        .catch((error) => {
          console.log(error);
          return reject(error.response);
        });
    });
  },

  updateJobDetails({ commit, getters }, { payload }) {
    const jobDetailsPayload = getters.getFormattedJobDetailPayload(payload);

    return new Promise((resolve, reject) => {
      axios.patch(routes.ajax.reviews.updateDetails(payload.id), jobDetailsPayload)
        .then((response) => {
          const { jobDetails, completionPercentage } = response.data.data;
          commit('updateCompletionPercentage', { completionPercentage });
          commit('updateJobDetails', { jobDetailsData: jobDetails });

          return resolve(response.data.data);
        })
        .catch((error) => {
          console.log(error);
          return reject(error.response);
        });
    });
  },

  updateReviewAnswers({ commit }, { payload }) {
    const { reviewId } = payload;
    // const { reviewId, answers: answerPayload } = payload;

    return new Promise((resolve, reject) => {
      axios.patch(routes.ajax.reviews.updateAnswers(reviewId), payload)
        .then((response) => {
          const { answers, completionPercentage } = response.data.data;

          commit('updateCompletionPercentage', { completionPercentage });
          commit('updateReviewAnswers', { answers });

          return resolve(response.data.data);
        })
        .catch((error) => {
          console.log(error);
          return reject(error.response);
        });
    });
  },

  submitReviewForModeration(store, { payload }) {
    const { reviewId } = payload;

    return new Promise((resolve, reject) => {
      axios.patch(routes.ajax.reviews.submit(reviewId))
        .then((response) => {
          return resolve(response.data.data);
        })
        .catch((error) => {
          console.log(error);
          return reject(error.response);
        });
    });
  },

  getUnfinishedReviews({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      dispatch('user/getUserReviews', null, { root: true })
        .then((reviews) => {
          const unfinishedReviews = reviews.filter((review) => review.review_status === 0);
          commit('updateUnfinishedReviews', { unfinishedReviews });
          return resolve(unfinishedReviews);
        })
        .catch((error) => {
          console.log(error);
          return reject(error.response);
        });
    });
  },
};

const {
  updateReviewAnswers,
  updateJobDetails,
} = actions;

export {
  updateReviewAnswers,
  updateJobDetails,
};

export default actions;
